import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import DiscountIcon from '@mui/icons-material/Discount';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const Container = styled(Box)(({ theme }) => ({
  color: '#ffffff',
  padding: theme.spacing(4),
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

const DiscountBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#f6a035',
  borderRadius: '10px',
  padding: theme.spacing(2),
  margin: theme.spacing(2),
  transition: 'transform 0.3s',
  minWidth: '250px',
  height: '200px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '&:hover': {
    transform: 'scale(1.05)',
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1),
    height: 'auto',
    minWidth: '100%',
    padding: theme.spacing(1.5),
  },
}));

const CenterImageContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '200px',
  width: '200px',
  margin: '0 auto',
  borderRadius: '20px',
  overflow: 'hidden',
  perspective: '1000px',
  animation: 'scaleEffect 5s infinite ease-in-out',
  '@keyframes scaleEffect': {
    '0%': {
      transform: 'scale(1) rotateY(0deg)',
    },
    '25%': {
      transform: 'scale(1.1) rotateY(20deg)',
    },
    '50%': {
      transform: 'scale(1.2) rotateY(0deg)',
    },
    '75%': {
      transform: 'scale(1.1) rotateY(-20deg)',
    },
    '100%': {
      transform: 'scale(1) rotateY(0deg)',
    },
  },
  [theme.breakpoints.down('sm')]: {
    height: '150px',
    width: '150px',
  },
}));

const CenterImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'transform 0.3s ease-out',
});

const images = [
  'ref4.png', // Replace with your image URLs
];

const DiscountComponent: React.FC = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Container className='component'>
      <Typography variant={isMobile ? 'h5' : 'h4'} gutterBottom sx={{ color: "rgba(57,69,78,2)", fontWeight: "bold" }} className=''>
        Exclusive Offer! <span style={{ background: "linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)" }}>Save 20%</span> on Your First Order!
      </Typography>
      <Typography variant="body1" gutterBottom sx={{ color: "rgba(0,0,0,0.7)" }}>
        Our 500+ professional UK writers are ready to give you a hand-made assignment.
      </Typography>

      <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} justifyContent="center" alignItems="center" marginBottom={2}>
        {/* Left Cards */}
        <Box display="flex" flexDirection="column" alignItems={isMobile ? 'center' : 'flex-end'} marginRight={isMobile ? 0 : 2}>
          <DiscountBox>
            <Box display="flex" alignItems="center" gap={1}>
              <GroupAddIcon />
              <Typography variant="h6">Referral Discounts</Typography>
            </Box>
            <Typography variant="body2">
              You’re eligible to avail referral discount based on how many friends you refer to our service.
            </Typography>
          </DiscountBox>
          <DiscountBox>
            <Box display="flex" alignItems="center" gap={1}>
              <DiscountIcon />
              <Typography variant="h6">Up to 5% off</Typography>
            </Box>
            <Typography variant="body2">
              You’re eligible to avail 5% discount when you place an order of 250 to 5000 words for the students.
            </Typography>
          </DiscountBox>
        </Box>

        {/* Center Image with automatic 3D scaling effect */}
        <CenterImageContainer className='component'>
          <CenterImage
            src={images[currentImage]}
            alt="Discount Image"
          />
        </CenterImageContainer>

        {/* Right Cards */}
        <Box display="flex" flexDirection="column" alignItems={isMobile ? 'center' : 'flex-start'} marginLeft={isMobile ? 0 : 2}>
          <DiscountBox>
            <Box display="flex" alignItems="center" gap={1}>
              <AssignmentTurnedInIcon />
              <Typography variant="h6">Up to 10% off</Typography>
            </Box>
            <Typography variant="body2">
              You’re eligible to avail 10% discount when you place an order of 5250 to 10000 words.
            </Typography>
          </DiscountBox>
          <DiscountBox>
            <Box display="flex" alignItems="center" gap={1}>
              <DiscountIcon />
              <Typography variant="h6">Up to 15% off</Typography>
            </Box>
            <Typography variant="body2">
              You’re eligible to avail 15% discount when you place an order of more than 10000 words.
            </Typography>
          </DiscountBox>
        </Box>
      </Box>
    </Container>
  );
};

export default DiscountComponent;
